module.exports = __webpack_public_path__ + "static/media/placeholder.2f4d7974.svg";